import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";
import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Spinner } from "@/components/Spinner";

interface IProps {
  fileType: "original" | "repaired";
}

export const UploadingFile: React.FC<IProps> = props => {
  const { css } = useFela();
  const { t } = useTranslation("converter");
  const { colors } = useTheme();

  const uploadingRepairedFile = props.fileType === "repaired";

  return (
    <div
      className={css({
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      })}
    >
      <Heading as="h4">
        {uploadingRepairedFile
          ? "Repairing your file"
          : t("uploading.uploadingFile")}
      </Heading>

      <Spinner />

      <p
        className={css({
          fontSize: 14,
          fontWeight: 600,
          textAlign: "center",
          maxWidth: 240,
          lineHeight: 1.7,
          color: colors.MAASTRICHT_BLUE,
        })}
      >
        <strong>
          {uploadingRepairedFile
            ? "We are currently repairing your file, please wait!"
            : t("uploading.uploadingFileDescription")}
        </strong>
      </p>
    </div>
  );
};
